/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Scrollbar, A11y, Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/mousewheel";
import { FaShare } from "react-icons/fa";
import { Link } from "react-router-dom";
import Images from "../../Images";
import copy from "clipboard-copy";
import { toast } from "react-toastify";
import "react-loading-skeleton/dist/skeleton.css";
import SwiperLoader from "./SwiperLoader";

export const truncateDescription = (description, maxLength) => {
  if (description.length <= maxLength) {
    return description;
  }

  return `${description.substring(0, maxLength)}...`;
};

const SwiperSlider = ({ copyAndShare, hideText, items, loading }) => {
  const [slidePerView, setSlidePerView] = useState(3);

  // Opens the device's native share sheet. Falls back to copying the link on
  // browsers without the Web Share API (most desktop browsers).
  const handleShare = async (item) => {
    const shareUrl = `${window.location.origin}/daily-updates`;
    const shareText = item?.text ? item.text : "";
    const sharePayload = {
      title: "Alpha1 Radio",
      text: shareText,
      url: shareUrl,
    };

    if (navigator.share) {
      try {
        await navigator.share(sharePayload);
        return;
      } catch (error) {
        // User dismissed the share sheet - nothing to report.
        if (error?.name === "AbortError") {
          return;
        }
      }
    }

    try {
      await copy(shareText ? `${shareText}\n\n${shareUrl}` : shareUrl);
      toast.success("Link copied to clipboard");
    } catch (error) {
      toast.error("Unable to share on this browser");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 991) {
        setSlidePerView(3);
      } else if (window.innerWidth >= 767) {
        setSlidePerView(2);
      } else {
        setSlidePerView(1);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {loading ? (
        <SwiperLoader slidesPerView={slidePerView} copyAndShare={copyAndShare} />
      ) : (
        <Swiper
          modules={[Scrollbar, A11y, Mousewheel]}
          spaceBetween={20}
          slidesPerView={slidePerView}
          scrollbar={{ draggable: true }}
          mousewheel={true}
        >
          {items?.length > 0 &&
            items?.map((item, index) => (
              <SwiperSlide key={item?.id ? item?.id : index}>
                {copyAndShare ? (
                  <div className="blog-post-thumb mx-3">
                    <div className="blog-post-img">
                      <img src={item?.image ? item?.image : ""} alt="" />
                    </div>
                    <div className="blog-content">
                      <div className="d-flex flex-column">
                        {!hideText && (
                          <div className="blog-content-text mt-2">
                            <h6>
                              {item?.text
                                ? truncateDescription(item?.text, 200)
                                : ""}
                            </h6>
                          </div>
                        )}
                        <div>
                          <div
                            className="btn main-button mt-4 mx-2"
                            onClick={() => copy(item?.text)}
                          >
                            <span>
                              <img
                                src={Images.BookIcon}
                                alt="book"
                                className="book-icon mb-1 me-1"
                              />
                              Copy
                            </span>
                          </div>
                          <div
                            className="btn main-button mt-4 mx-2"
                            onClick={() => handleShare(item)}
                          >
                            <FaShare className="mb-1 me-1" />
                            <span>Share</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Trending / Podcast cards: the whole card links to the details
                  // page. Title, sub-title and the "More" button are commented out.
                  <Link
                    style={{ textDecoration: "none" }}
                    to={item?.link ? item?.link : "/"}
                  >
                    <div className="blog-post-thumb mx-3">
                      <div className="blog-post-img">
                        <img src={item?.image ? item?.image : ""} alt="" />
                      </div>
                      {/*
                      <div className="blog-content">
                        <div className="blog-content-title mt-2">
                          <h4>{item?.title ? item?.title : ""}</h4>
                        </div>
                        <div className="blog-content-sub-title mt-2">
                          <h6>{item?.subtitle ? item?.subtitle : ""}</h6>
                        </div>
                        <div className="btn more-btn mt-4">
                          <div className="donate-btn">
                            <span>More</span>
                          </div>
                        </div>
                      </div>
                      */}
                    </div>
                  </Link>
                )}
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </>
  );
};

export default SwiperSlider;
